import { CommonModule } from '@angular/common';
import { Component, input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'gene-tab',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './tab.html',
  styleUrl: './tab.css'
})
export class TabComponent {
  /**
   * The label for the tab, which will be displayed in the tab header.
   */
  label = input.required<string>();

  /**
   * A unique ID for this tab. If not provided, one will be generated.
   * Needed to ensure the tab content is correctly associated.
   */
  id = input<string>();

  /**
   * Captures the content projected inside <gene-tab>.
   * This TemplateRef will be passed to ngTemplateOutlet by the parent GeneTabsComponent
   * to render the tab's content dynamically.
   */
  @ViewChild(TemplateRef, { static: true })
  contentTemplate!: TemplateRef<any>;
}
